import { HTTP_INTERCEPTORS, HttpClient, HttpInterceptor } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SEND_CONTACT_INFO } from 'src/app/shared/mocks/client-info-prospect.mock';
import { GET_OFFERS } from 'src/app/shared/mocks/offer.mock';

import { environment } from '../../../../../environments/environment';
import { AGREEMENTS_OFFERS } from '../../../mocks/agreements-offers.mock';
import { OFFERS_GET_BENEFITS_SUCCESS } from '../../../mocks/benefits.mock';
import { BIOCATCH_CHECK_SCORE, GET_SCORE_RESPONSE } from '../../../mocks/biocatch.mock';
import { GET_CARD_CATEGORY_BY_BRAND } from '../../../mocks/card-category-brand.mock';
import { GET_CLIENT_INFO } from '../../../mocks/client-information.mock';
import { EMPTY_SUCCESS } from '../../../mocks/empty.mock';
import { SEND_FINGER_PRINTS } from '../../../mocks/finger-prints.mock';
import { GENERIC_ERROR } from '../../../mocks/generic-error.mock';
import { GET_OTP } from '../../../mocks/get-otp.mock';
import { GET_PCO } from '../../../mocks/get-pco.mock';
import { PERFORM } from '../../../mocks/perfom.mock';
import { SEND_PROSPECT_OCCUPATION } from '../../../mocks/prospect-occupation.mock';
import { SEND_BACK_DOCUMENT } from '../../../mocks/send-back-document.mock';
import { SOLICITATION_ID_SUCCESS } from '../../../mocks/solicitation-id.mock';
import { SOLICITATION_INFO } from '../../../mocks/solicitation-info.mock';
import { VALIDATE_OTP } from '../../../mocks/validate-otp.mock';
import { PlatformCommunicatorInterceptor } from '../platform-communicator/platform-communicator.interceptor';

/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
@Injectable({
  providedIn: 'root',
})

/**
 * Definición de la clase MockService, clase que inicializa los mock de la aplicación
 *
 * *MockService class definition, sets app mock *
 *
 * @type {class}
 */
export class MockService {

  /**
   * Definición de la variable communicatorInterceptor como PlatformCommunicatorInterceptor
   *
   * *Defines communicatorInterceptor variable as PlatformCommunicatorInterceptor*
   *
   * @type {private}
   * @var {string} FLOW
   */
  private communicatorInterceptor: PlatformCommunicatorInterceptor;

  urls: any;

  /**
   * Constructor de la clase
   *
   * *Class Contstructor.*
   *
   * Inicializa los métodos para los modelos
   *
   * *Initialize method for models*
   *
   * @param {HttpInterceptor[]} interceptors
   */
  constructor(
    @Inject(HTTP_INTERCEPTORS) private interceptors: HttpInterceptor[],
    private _http: HttpClient,
  ) {
    this.loadCopies();
    this.interceptors.forEach(interceptor => {
      if (interceptor instanceof PlatformCommunicatorInterceptor) {
        this.communicatorInterceptor = interceptor;
      }
    });
  }

  /**
   * Función para cargar las copias que están guardadas en ./assets/resources/copies.json
   *
   * *Function to load copies saved in ./assets/resources/copies.json*
   *
   * @type {function}
   * @param {string} customURL
   */
  async loadCopies() {
    const url = './assets/resources/urls.mock.json';

    await this._http.get(url).toPromise().then(response => {
      this.urls = response['urlMock'];
    });
  }

  /**
   * Configura los mocks para el funcionamiento de la aplicación
   *
   * *Sets up the mocks for app functionality*
   *
   * @type {function}
   */
  setMocks(): void {
    if (environment.production) { return; }
    const endpoints: any[] = [
      {
        url: this.urls.ruleValidation,
        urlMocked: '/rule-validation/',
        mock_response: false, response: { body: BIOCATCH_CHECK_SCORE, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.score,
        urlMocked: '/api-v6-score/',
        ock_response: false, response: { body: GET_SCORE_RESPONSE, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },

      {
        url: this.urls.validateRules,
        urlMocked: '/validate-rules/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.acceptance,
        urlMocked: '/terms-conditions/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.assingProductType,
        urlMocked: '/assing-product-type/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.getAgreements,
        urlMocked: '/agreements-offers/',
        mock_response: false, response: { body: AGREEMENTS_OFFERS, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },
      {
        url: this.urls.sendBackDocumentInfo,
        urlMocked: '/send-back-document-info/',
        mock_response: false, response: { body: SEND_BACK_DOCUMENT, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.sendFrontDocumentInfo,
        urlMocked: '/front-document-info/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.sendFingerPrintsInfo,
        urlMocked: '/finger-prints-info/',
        mock_response: false, response: { body: SEND_FINGER_PRINTS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.getClientInformation,
        urlMocked: '/client-info/',
        mock_response: false, response: { body: GET_CLIENT_INFO, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.prospectOccupation,
        urlMocked: '/prospect-occupation/',
        mock_response: false, response: { body: SEND_PROSPECT_OCCUPATION, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.prospectBirthplace,
        urlMocked: '/prospect-birthplace/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.createCaseContactInfo,
        urlMocked: '/contact-info/',
        mock_response: false, response: { body: SEND_CONTACT_INFO, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.createCaseSolicitationsId,
        urlMocked: '/solicitation-id/',
        mock_response: false, response: { body: SOLICITATION_ID_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.prospectOfficeAddress,
        urlMocked: '/prospect-office-address/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.prospectFinancialInformation,
        urlMocked: '/prospect-financial/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.prospectIndependentWorker,
        urlMocked: '/prospect-independent-occupation/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.createCaseFinancials,
        urlMocked: '/prospect-create-financial/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.prospectForeignCurrencyProduct,
        urlMocked: '/prospect-foreign-product-detail/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.createCaseForeignOperation,
        urlMocked: '/prospect-create-case-foreign-operation/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.createCaseAddresses,
        urlMocked: '/prospect-create-case-address/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.prospectForeignCurrency,
        urlMocked: '/operation-currency/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.simulations,
        urlMocked: '/get-card-category-by-brand/',
        mock_response: false, response: { body: GET_CARD_CATEGORY_BY_BRAND, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.solicitations,
        urlMocked: '/get-pco/',
        mock_response: false, response: { body: GET_PCO, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.configAccount,
        urlMocked: '/offers-config/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.getBenefits,
        urlMocked: '/offers-get-benefits/',
        mock_response: false, response: { body: OFFERS_GET_BENEFITS_SUCCESS, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },
      {
        url: this.urls.createCasePerformSolicitation,
        urlMocked: '/create-case-perform-solicitation/',
        mock_response: false, response: { body: PERFORM, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.getCaseSolicitationInfo,
        urlMocked: '/get-case-solicitation-info/',
        mock_response: false, response: { body: SOLICITATION_INFO, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },
      {
        url: this.urls.updateCaseConfigAccount,
        urlMocked: '/update-case-account-config/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.selectAgreement,
        urlMocked: '/offers-select-agreement/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.creatCaseClients,
        urlMocked: '/create-client/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.createCaseProduct,
        urlMocked: '/create-product/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'PATCH',
      },
      {
        url: this.urls.getOtp,
        urlMocked: '/get-otp/',
        mock_response: false, response: { body: GET_OTP, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.validateOtp,
        urlMocked: '/validate-otp/',
        mock_response: false, response: { body: VALIDATE_OTP, status: 200 },
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.prospectContact,
        urlMocked: '/prospect-contact/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
      {
        url: this.urls.sessionId,
        urlMocked: '/session-id/',
        mock_response: false, response: { body: '', status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },
      {
        url: this.urls.getRates,
        urlMocked: '/rates/',
        mock_response: false, response: { body: EMPTY_SUCCESS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'GET',
      },
      {
        url: this.urls.offers,
        urlMocked: '/offersmock/',
        mock_response: false, response: { body: GET_OFFERS, status: 200 }, // integrado
        mock_error: false, errorResponse: { body: GENERIC_ERROR, status: 422 },
        method: 'POST',
      },
    ];

    this.communicatorInterceptor.setMockedEndPoints(endpoints);
  }
}
